import { lazy } from 'react';

const RadioGroup = lazy(() => import('./RadioGroup'));

export { RadioGroup };
